// TODO: Document, clean up/refactor legacy afAdRequest

import "./gaScrollTracker";
import { dataset } from "./dataset";

const setClientId = () => (window.afClientId = dataset.clientid);
const getClientId = () => window.afClientId || (window.parent && window.parent.afClientId ? window.parent.afClientId : "") || "";

setClientId();

window.afAdRequest = (type, adCampaign, provider = "", brand = "") => {
  const cb = Math.floor(Math.random() * 100000);
  let url = '';
  if (GLOBALS.ENV === 'development') {
    url = `${
      window.GLOBALS.API.EVENT_TRACKER_URI
    }/stats/adrequest/v1?clientId=${getClientId()}&type=${type}&adCampaign=${adCampaign}&provider=${provider}&brand=${brand}&cb=${cb}`;
  } else {
    url = `${
      window.GLOBALS.API.AD_REQUESTS
    }?clientid=${getClientId()}&type=${type}&adCampaign=${adCampaign}&provider=${provider}&brand=${brand}&cb=${cb}`;
  }


  const postImage = document.createElement("img");
  postImage.style.visibility = "hidden";
  postImage.style.width = "0px";
  postImage.style.height = "0px";
  postImage.src = url;
  postImage.onload = () => (postImage.src = "");

  document.body.appendChild(postImage);
};

while (window.afScripts.afterGlobalLoad.length > 0) {
  try {
    window.afScripts.afterGlobalLoad.shift()();
  } catch (err) {
    console.warn("Error in afterGlobalLoad: " + err); // eslint-disable-line no-console
  }
}
window.afScripts.afterGlobalLoad.push = func => {
  try {
    func();
  } catch (err) {
    console.warn("Error in afterGlobalLoad: " + err); // eslint-disable-line no-console
  }
};
